export default __webpack_public_path__ + "static/media/krzyzowka_1.c55f5fcb.jpg";